import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  projectId: "pharma-retail-online",
  appId: "1:716030652505:web:81c1fa5f21dafd977c0148",
  storageBucket: "pharma-retail-online.firebasestorage.app",
  apiKey: "AIzaSyD4bULRoOHU7V6wjBHVFpxpv1febi5ii90",
  authDomain: "pharma-retail-online.firebaseapp.com",
  messagingSenderId: "716030652505",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export let messaging = null;

// Initialize Messaging only if supported by the browser (prevents iOS Safari unhandled promise errors)
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
}).catch(() => {
  console.warn('Firebase Messaging not supported');
});
